interface OrderItem {
  displayOrder?: number;
}

const isNumber = (a: unknown): a is number => typeof a === 'number';

const resolveDisplayOrder = (orderItem: OrderItem) => {
  const value = orderItem.displayOrder;
  if (isNumber(value) && Number.isFinite(value)) return value;
  return Number.POSITIVE_INFINITY;
};

/**
 * Compares objects with an optional `displayOrder` property.
 *
 * For objects with numeric `displayOrder`, returns the comparison as the
 * difference between the 2 values.
 *
 * For objects with non-numeric `displayOrder`, will will return +infinity if comparing against
 * a number, or 0 if comparing two non numeric `displayOrder`s
 */
export const compareDisplayOrder = (a: OrderItem, b: OrderItem): number => {
  const orderA = resolveDisplayOrder(a);
  const orderB = resolveDisplayOrder(b);
  const comparison = orderA - orderB;

  if (Number.isNaN(comparison)) return 0;

  return comparison;
};

// DEP-2801: Phone cases for settings instructions
export const SHOW_INSTRUCTIONS_FOR_IPHONE_PRODUCT_TYPES = [
  'rough-sultana',
  'lovely-dingo',
  'cranky-beetroot',
  'whinging-rissole',
  'wagging-grub',
  'ferric-fortifier',
];

export const SHOW_INSTRUCTIONS_FOR_SAMSUNG_PRODUCT_TYPES = [
  'bush-brolly',
  'bush-magpie',
  'furphy-fiddlesticks',
  'tassie-wallaroo',
];
